// MapProvider — abstraksi peta. Pelaksanaan: Leaflet + OpenStreetMap (lalai), dengan sandaran
// senarai teks jika skrip peta gagal dimuat. Google Maps / Mapbox / MapLibre boleh ditambah
// dengan melaksanakan antara muka yang sama: mount(), setMarkers(), destroy().

import { esc } from './html.js';
import { t } from './i18n.js';

export class MapProvider {
  async mount(_el, _opts) { throw new Error('not implemented'); }
  setMarkers(_markers) {}
  destroy() {}
}

let leafletPromise = null;
function loadLeaflet() {
  if (window.L) return Promise.resolve(window.L);
  if (!leafletPromise) {
    leafletPromise = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      const s = document.createElement('script');
      s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      s.onload = () => resolve(window.L);
      s.onerror = () => { leafletPromise = null; reject(new Error('leaflet')); };
      document.head.appendChild(s);
      setTimeout(() => reject(new Error('timeout')), 6000);
    });
  }
  return leafletPromise;
}

export class LeafletOsmProvider extends MapProvider {
  async mount(el, { center = [4.2, 102.0], zoom = 6 } = {}) {
    const L = await loadLeaflet();
    this.L = L;
    this.map = L.map(el, { scrollWheelZoom: false, zoomControl: false }).setView(center, zoom);
    // Butang zum dengan tajuk dalam bahasa laman (lalai Leaflet ialah Bahasa Inggeris).
    L.control.zoom({ zoomInTitle: t('map.zoom_in'), zoomOutTitle: t('map.zoom_out') }).addTo(this.map);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: `&copy; ${esc(t('map.osm_contributors'))}`,
    }).addTo(this.map);
    this.layer = L.layerGroup().addTo(this.map);
    return this;
  }
  setMarkers(markers) {
    if (!this.map) return;
    this.layer.clearLayers();
    const pts = [];
    for (const m of markers) {
      const icon = this.L.divIcon({ className: '', html: `<span style="background:#fff;border:1.5px solid #14302B;border-radius:999px;padding:3px 8px;font:700 12px var(--ff);white-space:nowrap;color:#14302B">${esc(m.label)}</span>`, iconSize: null });
      const mk = this.L.marker([m.lat, m.lng], { icon, keyboard: true, title: m.title || m.label }).addTo(this.layer);
      if (m.href) mk.on('click', () => { location.hash = m.href; });
      pts.push([m.lat, m.lng]);
    }
    if (pts.length > 1) this.map.fitBounds(pts, { padding: [30, 30], maxZoom: 13 });
    else if (pts.length === 1) this.map.setView(pts[0], 13);
  }
  destroy() { this.map?.remove(); }
}

export class ListFallbackProvider extends MapProvider {
  async mount(el) { this.el = el; return this; }
  setMarkers(markers) {
    this.el.innerHTML = `<div class="map-fallback"><p class="muted">${esc(t('map.unavailable'))}</p><ul>${markers.map((m) => `<li><a href="${esc(m.href || '#')}">${esc(m.title || m.label)}</a> — ${m.lat.toFixed(3)}, ${m.lng.toFixed(3)}</li>`).join('')}</ul></div>`;
  }
}

export async function createMap(el, opts) {
  try {
    return await new LeafletOsmProvider().mount(el, opts);
  } catch {
    return new ListFallbackProvider().mount(el, opts);
  }
}
